import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 32, className = '' }) => {
  return (
    <div className={`logo ${className}`} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 440.000000 440.000000"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(0.000000,440.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
          <path d="M2122 3569 c-65 -12 -144 -52 -183 -91 -27 -27 -297 -419 -319 -463
-3 -5 -86 -131 -184 -280 -216 -326 -363 -549 -441 -670 -32 -49 -77 -119
-100 -155 -134 -206 -225 -363 -240 -416 -25 -82 -24 -221 3 -295 36 -102 101
-186 202 -264 73 -56 156 -90 257 -106 71 -11 92 -10 169 5 94 19 213 69 264
112 53 45 137 159 370 503 l43 64 96 -5 c167 -8 207 -37 341 -246 47 -73 102
-158 122 -190 20 -31 50 -80 67 -108 41 -69 87 -112 130 -124 47 -13 546 -13
636 0 92 14 181 63 267 148 121 119 172 270 148 440 -11 82 -26 110 -205 382
-67 102 -184 284 -260 405 -76 121 -146 231 -155 245 -29 44 -82 127 -315 495
-297 469 -307 485 -346 521 -93 85 -231 120 -367 93z m214 -105 c55 -23 100
-61 134 -111 17 -24 30 -46 30 -49 0 -2 -46 -73 -103 -157 -57 -83 -182 -269
-279 -412 -96 -143 -244 -363 -328 -488 -161 -239 -222 -308 -288 -327 -50
-14 -469 -13 -477 1 -4 5 0 18 8 27 8 9 16 22 18 27 2 6 40 64 83 130 43 66
131 199 194 295 391 594 648 979 671 1003 30 34 92 67 141 78 48 11 151 2 196
-17z m399 -529 c87 -137 168 -266 180 -285 102 -158 135 -211 137 -222 2 -10
-53 -14 -252 -18 -251 -5 -256 -5 -311 -32 -103 -49 -161 -119 -384 -468 -78
-123 -108 -169 -191 -295 -43 -66 -81 -124 -83 -130 -2 -5 -7 -12 -10 -15 -4
-3 -33 -45 -67 -95 -131 -196 -220 -316 -263 -353 -109 -95 -313 -133 -445
-84 -133 51 -256 170 -298 289 -16 46 -19 76 -16 145 5 100 22 140 142 329
l72 114 290 5 c320 6 326 7 411 76 34 28 113 132 193 254 24 38 76 115 255
380 106 157 252 374 325 483 107 159 136 196 145 185 7 -7 83 -125 170 -263z
m399 -627 c7 -13 34 -54 58 -93 24 -38 62 -98 84 -132 21 -35 69 -110 107
-167 37 -58 67 -109 67 -114 0 -5 -35 -63 -78 -128 -43 -66 -113 -173 -156
-239 -42 -66 -135 -209 -206 -317 l-129 -198 -69 0 c-80 0 -81 1 -157 120 -26
41 -82 128 -124 192 -42 65 -92 143 -111 173 -45 73 -88 115 -153 151 -43 23
-67 29 -140 32 -58 3 -90 9 -93 17 -3 7 8 32 24 56 16 24 60 91 97 149 37 58
82 128 100 155 18 28 54 84 81 125 26 41 68 96 92 123 98 104 143 115 454 116
236 1 238 1 252 -21z m445 -690 c28 -43 63 -103 78 -134 23 -50 25 -65 21
-152 -5 -119 -30 -179 -111 -267 -58 -64 -124 -106 -204 -130 -56 -17 -353
-21 -353 -5 0 8 130 217 180 289 10 14 33 51 53 81 137 218 270 411 276 404 4
-5 31 -44 60 -86z"/>
        </g>
      </svg>
    </div>
  );
};